<template>
    <rkm-layout-body title="FECHAMENTO DE FAA">
        <rkm-overlay>
            <rkm-layout-content>
                <Form
                    @busy="busy = $event"
                    @data="data = $event"
                    @periodo="periodo = $event"
                />
            </rkm-layout-content>

            <rkm-layout-content>
                <List
                    :busy="busy"
                    :data="data"
                    :periodo="periodo"
                />
            </rkm-layout-content>
        </rkm-overlay>
    </rkm-layout-body>
</template>

<script>
import Form from '@/components/pronto-atendimento/fechamento-faa/Form'
import List from '@/components/pronto-atendimento/fechamento-faa/List'

export default {
    components: { List, Form },
    data: () => ({
        busy: false,
        data: {},
        periodo: null,
    })
}
</script>